import getProvideFile from '@/utils/getProvideFile';
import * as common from './common';

const resolve = require.context(
  './products/',
  false,
  /\.js$/,
  'lazy',
);

export default getProvideFile(common, resolve);
